import React from 'react';

const pulseStyle = `
@keyframes hgPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.04); opacity: 0.88; }
}
`;

const GoldHourglass = ({ size = 200, className = '' }) => (
  <>
    <style>{pulseStyle}</style>
    <div
      className={`relative flex items-center justify-center ${className}`}
      style={{ width: size, height: size * 1.3 }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/hourglass_emblem_transparent.png`}
        alt="Crafting documents..."
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          animation: 'hgPulse 2s ease-in-out infinite',
        }}
      />
    </div>
  </>
);

export default GoldHourglass;
